import { createSelector } from '@ngrx/store';
import { historyOrdersState } from '../root';

export const getHistoryOrderByOrderGUID = (orderGUID: Nullable<string>) =>
    createSelector(historyOrdersState, (historyOrders) => historyOrders?.orders?.find((order) => order.data != null && order.orderGUID === orderGUID) || null);
